import { Observable } from 'rxjs';
import AuthApi from '../../api/auth';
import AuthAction from '../actions/auth';
import AuthToken from '../../lib/common/auth-token';
import AUTH_ACTIONS from '../../constants/actions/auth';
import { toast } from 'react-toastify';
import INSPECTION_DETAIL_ACTIONS from '../../constants/actions/inspection';
import InspectionApi from '../../api/inspection';
import { MESSAGES_NOTIFY, CONFIG_NOTIFY } from '../../constants/app/inspection';

class AuthEpic {
	static login = (action$, store, deps) => action$
        .ofType(AUTH_ACTIONS.LOGIN)
        .switchMap(({ payload }) => {
            const api = new AuthApi(action$, store, deps);
            // http
            const request = api.login(payload)
                .flatMap(response => Observable.concat(
                    Observable.of(AuthAction.loginOk(response.response)),
                ))
                .catch(error => Observable.concat(
                    Observable.of(AuthAction.loginError({
                        message: error.message,
                        status: error.status
					})),
                ));
            return Observable.concat(
                request,
            );
        });
    static loginOk = (action$, store, deps) => action$
        .ofType(AUTH_ACTIONS.LOGIN_OK)
        .switchMap(({ payload }) => {
            AuthToken.setToken(payload);
            
            return Observable.concat(
                Observable.of(AuthAction.loadToken()),
            );
        });
        
	    static logout = (action$, store, deps) => action$
        .ofType(AUTH_ACTIONS.LOGOUT_OK)
        .switchMap(({ payload }) => {
            AuthToken.setToken(null);
            return Observable.empty();
		});
	static me = (action$, store, deps) => action$
        .ofType(AUTH_ACTIONS.ME)
        .switchMap(({ payload }) => {
            const api = new AuthApi(action$, store, deps);
            const request = api.me()
                .flatMap(response => Observable.concat(
                    Observable.of(AuthAction.meOk(response)),
                ))
                .catch(error => Observable.concat(
                    Observable.of(AuthAction.meError({
                        message: error.message,
                        status: error.status
					})),
					Observable.of(AuthAction.meReset())
                ));
            return Observable.concat(
                request
            );
        });
        static getReportInspection = (action$, store, deps) => action$
            .ofType(AUTH_ACTIONS.LOAD_INSPECTION_REPORT)
            .flatMap(({ payload }) => {
                const api = new InspectionApi(action$, store, deps);
                const request = api.getReport({date: payload})
                .map(response => AuthAction.getReportInspectionOk(response))
                .catch(error => Observable.of(AuthAction.getReportInspectionError({
                    message: error.message,
                    status: error.status
                })));
                return request;
            });
        // static getReportInspectionError= (action$, store, deps) => action$
        //     .ofType(AUTH_ACTIONS.LOAD_INSPECTION_REPORT_ERROR)
        //     .flatMap(() => {
        //         toast.error(MESSAGES_NOTIFY.MESSAGE_TO_GET_REPORT_INSPECTIONS_ERROR, CONFIG_NOTIFY);
        //         return Observable.empty();
        //     });
    }

const AuthEpics = (action$, store, deps) => Observable.merge(
    AuthEpic.login(action$, store, deps),
	AuthEpic.loginOk(action$, store, deps),
	AuthEpic.me(action$, store, deps),
    AuthEpic.logout(action$, store, deps),
	AuthEpic.getReportInspection(action$, store, deps),
	// AuthEpic.getReportInspectionError(action$, store, deps)
);

export default AuthEpics;



// WEBPACK FOOTER //
// ./src/redux/epics/auth.js